import { globalEntitlements } from '../utils/globalEntitlements';

export const OPERATING_AGREEMENT_CONFIG = {
  hero: {
    buyBox: [
      {
        bulletPoints: [
          { title: 'productPage.operatingAgreement.buyBox.bulletPoint1' },
          { title: 'productPage.operatingAgreement.buyBox.bulletPoint2' },
          { title: 'productPage.operatingAgreement.buyBox.bulletPoint3' },
        ],
        productName: 'productPage.operatingAgreement.buyBox.productName',
        veloCta: {
          displayVeloCta: true,
          promptMessageId: 'productPage.operatingAgreement.buyBox.veloCta.prompt',
          topic: 'operating-agreement',
        },
        interactService: {
          service: 'operating_agreement',
          ctaType: 'internalCheckout',
        },
      },
    ],
    headerPicture: {
      src: '/s2/raster/laptop-ceramics-chat.png',
      alt: 'productPage.operatingAgreement.heroPicture.altText',
    },
    headline: 'productPage.operatingAgreement.page.headline',
    partnerLogo: {},
    partnerReviewBlanks: [],
    subheader: 'productPage.operatingAgreement.page.subheader',
  },
  benefit: {
    title: 'productPage.operatingAgreement.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/homeworkrounded.svg',
        title: 'productPage.operatingAgreement.valueProp.propTitle1',
        description: 'productPage.operatingAgreement.valueProp.shortCopy1',
      },
      {
        icon: '/s2/material-icons/thumbuprounded.svg',
        title: 'productPage.operatingAgreement.valueProp.propTitle2',
        description: 'productPage.operatingAgreement.valueProp.shortCopy2',
      },
      {
        icon: '/s2/material-icons/personaddaltrounded.svg',
        title: 'productPage.operatingAgreement.valueProp.propTitle3',
        description: 'productPage.operatingAgreement.valueProp.shortCopy3',
      },
    ],
  },
  highlight: {
    icon: '/s2/material-icons/workspacesrounded.svg',
    title: 'productPage.operatingAgreement.topFeature.title',
    subheader: 'productPage.operatingAgreement.topFeature.subheader',
    image: '/s2/raster/sign-shop-open.png',
    alt: 'productPage.operatingAgreement.topFeature.altText',
  },
  howItWorks: {
    title: 'productPage.operatingAgreement.howItWorks.title',
    items: [
      {
        title: 'productPage.operatingAgreement.howItWorks.step1',
        description: 'productPage.operatingAgreement.howItWorks.shortDescription1',
      },
      {
        title: 'productPage.operatingAgreement.howItWorks.step2',
        description: 'productPage.operatingAgreement.howItWorks.shortDescription2',
      },
      {
        title: 'productPage.operatingAgreement.howItWorks.step3',
        description: 'productPage.operatingAgreement.howItWorks.shortDescription3',
      },
    ],
    image: '/s2/raster/store-clothes-smiling.png',
    alt: 'productPage.operatingAgreement.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true,
  },
  faqs: {
    title: 'productPage.operatingAgreement.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.operatingAgreement.frequentlyAskedQuestions.faq1',
        answer: 'productPage.operatingAgreement.frequentlyAskedQuestions.faqAnswer1',
      },
      {
        question: 'productPage.operatingAgreement.frequentlyAskedQuestions.faq2',
        answer: 'productPage.operatingAgreement.frequentlyAskedQuestions.faqAnswer2',
      },
      {
        question: 'productPage.operatingAgreement.frequentlyAskedQuestions.faq3',
        answer: 'productPage.operatingAgreement.frequentlyAskedQuestions.faqAnswer3',
      },
    ],
  },
  assistance: {
    title: 'productPage.operatingAgreement.needAssistance.title',
    getInTouch: 'productPage.operatingAgreement.needAssistance.getInTouch',
    actions: 'productPage.operatingAgreement.needAssistance.actions',
  },
  getBuyButtonConfig: globalEntitlements({ ctaText: 'productPage.operatingAgreement.buyBox.buttonLabel' })
    .formedByZb()
    .businessFormed()
    .currentProductNotPurchased()
    .build(),
};
